// Market Signals — the medium-term, time-bounded market-state tier (see market-signals-plan.md).
// Mirrors the backend BrandSignal model. kind / status are strings (TS-level enums, never DB enums).

import type { Observation } from "@/types/agent.type";

export type SignalKind =
  | "trend"
  | "tone_shift"
  | "positioning_shift"
  | "platform_shift"
  | "cultural_moment"
  | "category_shift"
  | "audience_shift"
  // Filed by the agents; the backend's SignalKind has them, people never pick them.
  | "competitive_pattern"
  | "active_campaign"
  | "identity";

export type SignalStatus =
  | "pending"
  | "active"
  | "expired"
  | "superseded"
  | "graduated"
  | "dismissed";

export interface MarketSignal {
  id: string;
  brandId: string;
  kind: SignalKind | string;
  title: string;
  body: string;
  confidence: number | null;
  recommendedValidUntil: string | null;
  validFrom: string;
  validUntil: string | null;
  status: SignalStatus | string;
  groundingObservations: Observation[];
  groundingFactIds: string[];
  sourceRunId: string | null;
  supersededBySignalId: string | null;
  graduatedFactId: string | null;
  graduatedAt: string | null;
  acceptedByUserId: string | null;
  acceptedAt: string | null;
  createdByUserId: string | null;
  createdAt: string;
  updatedAt: string;
}

export const SIGNAL_KINDS: SignalKind[] = [
  "trend",
  "tone_shift",
  "positioning_shift",
  "platform_shift",
  "cultural_moment",
  "category_shift",
  "audience_shift",
];

/** Slow-moving kinds where "until superseded" (validUntil = null) is allowed.
    Mirrors the backend's EVERGREEN_CANDIDATE_KINDS, which rejects null for any other kind. */
export const EVERGREEN_CANDIDATE_KINDS: SignalKind[] = [
  "positioning_shift",
  "audience_shift",
  "identity",
];
